module.exports = __webpack_public_path__ + "img/passport-example.43a3e0aa.jpg";